module.exports = __webpack_public_path__ + "img/X.ea5b00c3.png";